<template>
  <div class="new-product body">
    <el-container>
      <!-- <SafeAside /> -->

      <el-main>
        <div class="bg-White p-3 mt-2">
          <el-row :gutter="10">
            <el-col :xl="10" :lg="10" :md="24" :sm="24">
              <div class="searchForm">
                <label for="">وصف مصدر المبلغ </label>
                <el-input
                  class="mt-2 input1"
                  @focus="$event.target.select()"
                  v-model="form.comment"
                  @keyup.enter.native="focusNext"
                ></el-input>
              </div>
            </el-col>
            <el-col :xl="4" :lg="4" :md="12" :sm="12">
              <div class="searchForm">
                <label for="search">المبلغ 
                   <span class="mr-5" v-if="form.cost">( {{convertNumber(form.cost)}} )</span>
                </label>
                <el-input
                  class="mt-2 input2"
                  id="cost"
                  type="number"
                  @focus="$event.target.select()"
                  v-model="form.cost"
                  controls-position="right"
                  @keyup.enter.native="focusNext"
                ></el-input>
              </div>
            </el-col>

            <el-col :xl="4" :lg="4" :md="12" :sm="12">
              <br />
              <el-button
                class="mt-2"
                type="warning"
                @click="addSafeOperation()"
              >
                تسجيل</el-button
              >
            </el-col>
          </el-row>
        </div>
      </el-main>
    </el-container>
  </div>
</template>
<script>
// import SafeAside from "@/components/SafeAside.vue";
import axiosApi from "@/plugins/axios.js";

export default {
  name: "NewCustomer",
  // components: { SafeAside },
  data() {
    return {
      index: 1,
      false: false,
      form: {
        comment: "",
        cost: "",
        type: 1,
        inventory_id: 1,
      },
    };
  },
  created() {},
  mounted() {},

  methods: {
     convertNumber(val){
      if(val>0){
      return Number(val).toLocaleString('en-US');
      }else{
        return "";
      }

    },
    focusNext() {
      if (this.index < 2) {
        this.index += 1;
      } else {
        this.index = 1;
      }

      let input = ".input" + this.index + " input";
      console.log(input);
      setTimeout(() => {
        document.querySelector(input).focus();
      }, 100);
    },

    addSafeOperation() {
      axiosApi
        .post("safe/operation", this.form)
        .then(() => {
          this.$notify({
            title: "تمت العملية بنجاح",
            message: "تم حفظ بيانات العملية بنجاح",
            type: "success",
            duration: 1500,
          });
          setTimeout(() => {
            location.reload();
          }, 500);
        })
        .catch(() => {
          this.$notify({
            title: "حدث خطأ",
            message: "عفوا لم تتم العملية ",
            type: "error",
            duration: 1500,
          });
        });
    },
  },
};
</script>